import { useQuery } from "@tanstack/react-query";
import { PsaStateMigrationStatus } from "api/client.generated";
import useApi from "../useApi";

interface UsePsaStateMigrationStatusReturn {
  psaMigrationStatus: PsaStateMigrationStatus | undefined;
  isPsaMigrationStatusFetching: boolean;
}

const usePsaStateMigrationStatus = (): UsePsaStateMigrationStatusReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getPsaStateMigrationStatus"],
    queryFn: () => partnersMigrationClient.getPsaStateMigrationStatus(),
  });

  return { psaMigrationStatus: data, isPsaMigrationStatusFetching: isFetching };
};

export default usePsaStateMigrationStatus;
